import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

interface Props {
  message: string
}

export const InactiveChat = ({ message }: Props) => {
  return (
    <div className="px-2 pb-4">
      <div className="border border-line-subdued rounded-base shadow-base">
        <div className="flex items-center justify-center text-center text-content-muted gap-2 p-4">
          <p className="text-sm">{message}</p>
          <SvgIcon name="alert-circle" />
        </div>
      </div>
    </div>
  )
}
